var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.18038 12.8337H8.48621C9.50617 12.8337 10.3425 12.0684 10.4733 11.0837H10.8195C11.9299 11.0837 12.8333 10.1802 12.8333 9.06993V3.18072C12.8333 2.07046 11.9299 1.16699 10.8196 1.16699H5.51371C4.40346 1.16699 3.49999 2.07046 3.49999 3.18072V3.50033H3.18038C2.07012 3.50033 1.16666 4.40379 1.16666 5.51405V10.8199C1.16666 11.9302 2.07012 12.8337 3.18038 12.8337ZM4.66666 3.18072C4.66666 2.71364 5.04664 2.33366 5.51371 2.33366H10.8195C11.2867 2.33366 11.6667 2.71364 11.6667 3.18072V9.06988C11.6667 9.53701 11.2867 9.91699 10.8196 9.91699H10.5V5.51405C10.5 4.40379 9.59652 3.50033 8.48627 3.50033H4.66666V3.18072ZM2.33332 5.51405C2.33332 5.04698 2.71331 4.66699 3.18038 4.66699H8.48621C8.95334 4.66699 9.33332 5.04698 9.33332 5.51405V10.8199C9.33332 11.287 8.95334 11.667 8.48627 11.667H3.18038C2.71331 11.667 2.33332 11.287 2.33332 10.8199V5.51405Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.f53f52b1313f3fcbb0c4e4c3527527b9.svg";
export { ForwardRef as ReactComponent };